import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true, // send session_token cookie
});

// --- Auth ---
export const fetchMe = async () => {
  const { data } = await http.get("/auth/me");
  return data;
};
export const logout = async () => {
  const { data } = await http.post("/auth/logout");
  return data;
};

// --- Markets ---
export const fetchMarkets = async (params = {}) => {
  const { data } = await http.get("/markets", { params });
  return data;
};
export const fetchMarket = async (id) => {
  const { data } = await http.get(`/markets/${id}`);
  return data;
};
export const fetchTrending = async (limit = 15) => {
  const { data } = await http.get("/trending", { params: { limit } });
  return data;
};
export const fetchStats = async () => {
  const { data } = await http.get("/stats");
  return data;
};
export const fetchCategories = async () => {
  const { data } = await http.get("/categories");
  return data;
};

// --- AI ---
export const requestPrediction = async (id, force = false) => {
  const { data } = await http.post(`/predict/${id}`, null, { params: { force } });
  return data;
};
export const getCachedPrediction = async (id) => {
  try {
    const { data } = await http.get(`/predictions/${id}`);
    return data;
  } catch {
    return null;
  }
};
export const fetchEdgeLeaderboard = async (limit = 20) => {
  const { data } = await http.get("/edge-leaderboard", { params: { limit } });
  return data;
};

export const fetchMarketHistory = async (id, interval = "1w", fidelity = 60) => {
  const { data } = await http.get(`/markets/${id}/history`, {
    params: { interval, fidelity },
  });
  return data;
};

export const fetchTopMovers = async (window = "24h", limit = 10) => {
  const { data } = await http.get("/top-movers", { params: { window, limit } });
  return data;
};

export const fetchAccuracy = async (refresh = false) => {
  const { data } = await http.get("/accuracy", { params: { refresh } });
  return data;
};

export const fetchAccuracyTrend = async () => {
  const { data } = await http.get("/accuracy/trend");
  return data;
};

export const fetchEventWatchers = async (id) => {
  const { data } = await http.get(`/events/${id}/watchers`);
  return data;
};

// --- Events ---
export const fetchEvents = async (params = {}) => {
  const { data } = await http.get("/events", { params });
  return data;
};
export const fetchEvent = async (id) => {
  const { data } = await http.get(`/events/${id}`);
  return data;
};
export const rankEvent = async (id, force = false) => {
  const { data } = await http.post(`/events/${id}/rank`, null, { params: { force } });
  return data;
};
export const getCachedEventRanking = async (id) => {
  try {
    const { data } = await http.get(`/events/${id}/ranking`);
    return data;
  } catch {
    return null;
  }
};

// --- Watchlist ---
export const getWatchlist = async () => {
  const { data } = await http.get("/watchlist");
  return data;
};
export const addWatchlist = async (item) => {
  const { data } = await http.post("/watchlist", item);
  return data;
};
export const removeWatchlist = async (id) => {
  const { data } = await http.delete(`/watchlist/${id}`);
  return data;
};

// --- Alerts ---
export const fetchAlerts = async (limit = 50) => {
  const { data } = await http.get("/alerts", { params: { limit } });
  return data;
};
export const fetchAlertsUnread = async () => {
  const { data } = await http.get("/alerts/unread-count");
  return data;
};
export const markAlertRead = async (id) => {
  const { data } = await http.post(`/alerts/${id}/read`);
  return data;
};
export const markAllAlertsRead = async () => {
  const { data } = await http.post("/alerts/read-all");
  return data;
};
export const deleteAlert = async (id) => {
  const { data } = await http.delete(`/alerts/${id}`);
  return data;
};

// --- Settings ---
export const getSettings = async () => {
  const { data } = await http.get("/settings");
  return data;
};
export const updateSettings = async (patch) => {
  const { data } = await http.put("/settings", patch);
  return data;
};
